// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_jqK","cls2":"PackPreviewRows-cls2_3mq PackPreviewRows-cls1_jqK"};